<!-- <div class="data-block">
  <div class="data-block__section">
    <h3 class="data-block__section-header">Based GA Aircraft</h3>
    <div class="data-block__section-body">
      <div class="data-block__item">
        <div class="data-block__label">Single Engine:</div>
        <div class="data-block__value">{{activity.gaAircraftSingleEngine | number}}</div>
      </div>
      <div class="data-block__item">
        <div class="data-block__label">Multi Engine:</div>
        <div class="data-block__value">{{activity.gaAircraftMultiEngine}}</div>
      </div>
      <div class="data-block__item">
        <div class="data-block__label">Jets:</div>
        <div class="data-block__value">{{activity.gaAircraftJet}}</div>
      </div>
      <div class="data-block__item">
        <div class="data-block__label">Helicopters</div>
        <div class="data-block__value">{{activity.gaAircraftHelo}}</div>
      </div>
      <div class="data-block__item">
        <div class="data-block__label">Gliders:</div>
        <div class="data-block__value">{{activity.gaAircraftGliders}}</div>
      </div>
      <div class="data-block__item">
        <div class="data-block__label">Ultralights:</div>
        <div class="data-block__value">{{activity.gaAircraftUltralights}}</div>
      </div>
    </div>
  </div>
  <div class="data-block__section">
    <h3 class="data-block__section-header">Airport Activity</h3>
    <div class="data-block__section-body">
      <div class="data-block__item">
        <div class="data-block__label">GA Local:</div>
        <div class="data-block__value">{{activity.activityGaLocal | number}}</div>
      </div>
      <div class="data-block__item">
        <div class="data-block__label">GA Itinerant:</div>
        <div class="data-block__value">{{activity.activityGaItinerant | number}}</div>
      </div>
      <div class="data-block__item">
        <div class="data-block__label">Commercial:</div>
        <div class="data-block__value">{{activity.activityCommercial | number}}</div>
      </div>
      <div class="data-block__item">
        <div class="data-block__label">Air Taxi:</div>
        <div class="data-block__value">{{activity.activityAirTaxi | number}}</div>
      </div>
      <div class="data-block__item">
        <div class="data-block__label">Military:</div>
        <div class="data-block__value">{{activity.activityMil | number}}</div>
      </div>
      <div class="airport-activity__activity-ending-date">(12-month period ending on {{activity.activityEndingDate | date:'shortDate'}})</div>

    </div>
  </div>
</div> -->
<div class="detail-page__placeholder">
  <div class="detail-page__placeholder-message">To view based aircraft and activity information for this airport visit the FAA's Airport Operations site: <a target="_blank" href="https://aspm.faa.gov/opsnet/sys/Airport.asp">https://aspm.faa.gov/opsnet/sys/Airport.asp</a>.</div>
</div>
